import { Ref } from 'vue';
import { inputField } from '@/ui/components/form';
import { Task, useValidation } from '@/ui/concerns';
import { Category, validate } from '@/entities/category';
import { apiErrorMessage } from '@/ui/components';
import { t } from '@/ui/i18n/i18n';

export function useCategoryForm(record: Ref<Category>, task: Task) {
  const {
    validationErrors,
    hasNoValidationErrors,
    showValidationErrors,
  } = useValidation(validate, record, task.state);

  const handleSubmit = () => {
    showValidationErrors.value = true;
    if (hasNoValidationErrors.value) {
      task.run();
    }
  };

  const formFields = () => [
    inputField({
      name: 'title',
      label: t('category.title'),
      placeholder: t('category.enter-title'),
      value: record.value.title,
      required: true,
      errors: validationErrors.value,
      disabled: task.state.value.pending,
    },

    v => {
      record.value.title = v;
    }),

    apiErrorMessage(task.state.value),
  ];

  return {
    formFields,
    handleSubmit,
  };
}
